"use client";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import React from "react";
import { getStrapiMedia } from "@aicodepro/web-builder-utils";
import { renderButtonStyle } from "../utils/render-button-style";
import CenterFocus from "./Hero/CenterFocus";
import  LeftFocused from "./Hero/LeftFocus";
import  RightFocused from "./Hero/RightFocus";
import Hero_BackgroundVisual from "./Hero/BackgroundVisuals";
import Hero_Adaptive from "./Hero/Adaptive";
interface Button {
  id: string;
  url: string;
  text: string;
  type: string;
  newTab: boolean;
}

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
      mime: string;
    };
  };
}

interface HeroProps {
  data: {
    id: string;
    title: string;
    description: string;
    picture: Picture;
    buttons: Button[];
    isLive: boolean;
    layout: string;
    useH1Tag?: boolean;
    productBenefits?: string[];
  };
}

const Hero = ({ data }: HeroProps) => {
  const pathname = usePathname();
  if (!data?.isLive) return null;

  const picUrl = getStrapiMedia(data.picture?.data?.attributes?.url);
  const picAlt =
    data.picture?.data?.attributes?.alternativeText ||
    "QuickHenna Herbal Product";
// console.log("Hero dtaa",data.layout);

  return data.layout === "RightFocus" ? (
    <RightFocused data={data} />
  ) :
  data.layout==="CenterFocus" ? (
    <CenterFocus data={data} />
  )
  :
  data.layout==="LeftFocus" ? (
    <LeftFocused data={data} />
  ):
  data.layout==="BgVisual" ? (
    <Hero_BackgroundVisual data={data} />
  )
  :
  data.layout==="Adaptive" ? (
    <Hero_Adaptive data={data} />
  )
  :
   (
    <CenterFocus data={data} />
  );
};

export default Hero;
